import { isCompanyPortalResponse, isRedirectResponse } from '@/company-portal/add-file/add-file-utils';
import { useAddFileStore } from '@/company-portal/add-file/add-file.store';
import type { AddFileSubmissionEventClient, AddFileSubmissionResponse } from '@/company-portal/add-file/add-file.types';
import { useCurrentUserStore } from '@/stores/current-user.store';

export const useAddFileAnalytics = () => {
    const addFileStore = useAddFileStore();
    const currentUserStore = useCurrentUserStore();

    const trackSubmissionEvents = (response: AddFileSubmissionResponse | null) => {
        if (isRedirectResponse(response) || !isCompanyPortalResponse(response)) {
            return;
        }
        if (!response.success) {
            return;
        }

        const sharedProps = {
            role: currentUserStore.currentUser?.role?.toLowerCase(),
            'file number': addFileStore.refNumber,
            account: response.account ? `${response.account.id}: ${response.account.name}` : '',
            company: addFileStore.company ? `${addFileStore.company.id}: ${addFileStore.company.name}` : '',
            branch: addFileStore.branch ? `${addFileStore.branch.id}: ${addFileStore.branch.name}` : '',
            tps: 'none',
        };

        const track = (action: string, client: AddFileSubmissionEventClient, documentName?: string) =>
            window.amplitude?.logEvent('file action', {
                ...sharedProps,
                action,
                client: client.email,
                'client type': client.type,
                ...(documentName ? { 'document name': documentName } : {}),
            });

        response.request_bank_clients?.forEach(client => track('request wire instructions', client));
        response.request_id_verification_clients?.forEach(client => track('request identity verification', client));
        response.send_wire_doc_clients?.forEach(client =>
            client.filenames?.forEach(filename => track('send wire instructions', client, filename)),
        );
        response.documents_clients?.forEach(client =>
            client.filenames?.forEach(filename => {
                const isSigned = response.client_signed_documents?.[client.email]?.includes(filename);
                track(isSigned ? 'sign document' : 'send document', client, filename);
            }),
        );
    };

    return { trackSubmissionEvents };
};
